import { render, staticRenderFns } from "./LessonSliderComponent.vue?vue&type=template&id=5a21cee4&scoped=true&"
import script from "./LessonSliderComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSliderComponent.vue?vue&type=style&index=0&id=5a21cee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a21cee4",
  null
  
)

export default component.exports